import type { ActiveAttestationCycleResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetActiveAttestationCycleQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActiveAttestationCycleDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

/**
 * Maps TRPC active attestation cycle data to match the GraphQL query structure.
 */
const mapTrpcActiveAttestationCycleToGraphQL = (
  trpcData: ActiveAttestationCycleResponseRow[]
): GetActiveAttestationCycleQuery => {
  return {
    attestation_cycle: trpcData.map((cycle) => {
      if (!cycle.document_file) {
        throw new Error('Document file is missing in attestation cycle data');
      }

      return {
        ...cycle,
        parent: cycle.document_file,
      };
    }),
  };
};

type UseGetActiveAttestationCycleArgs = {
  parentDocumentId: string;
};

export const useGetActiveAttestationCycle = createQueryHook<
  UseGetActiveAttestationCycleArgs,
  ActiveAttestationCycleResponseRow[],
  GetActiveAttestationCycleQuery
>({
  trpcQueryOptions: (trpc, { parentDocumentId }) =>
    trpc.frontend.attestationCycle.activeByDocumentId.queryOptions({
      parentDocumentId,
    }),
  mapTrpcDataToGraphQL: mapTrpcActiveAttestationCycleToGraphQL,
  graphqlDocument: GetActiveAttestationCycleDocument,
  graphqlVariables: ({ parentDocumentId }) => ({ parentDocumentId }),
});
